import { isLoggedIn, logout, tryLogin } from '@/services/auth';
import type { RouteRecordRaw } from 'vue-router';

export const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    component: () => import('../layouts/LoggedLayout.vue'),
    beforeEnter: () => {
      if (isLoggedIn() || tryLogin()) {
        return true
      }

      logout();
      return false
    },
    children: [
      {
        path: '',
        name: 'NextSteps',
        component: () => import('../pages/next-steps/NextStepsPage.vue'),
      },
      {
        path: 'form/:formId',
        name: 'Form',
        component: () => import('../pages/form/FormPage.vue'),
        props: true,
      }
    ],
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/',
  },
]
